// @file Dummy react-native module

// We have an import graph that leads to react-native:
// - This Vue 3/Vite environment
//   - A file in `app/javascript` that imports from `@padlet/beethoven-client`
//     - @padlet/beethoven-client
//       - @padlet/pixel-ratio
//         - react-native
// The react-native module is not used in the browser, but because
// of the way Vite works, it always tries to resolve react-native
// (we can make production mode ignore it, but not dev mode).
// Luckily, there's a very simple and clever workaround: declaring
// an import alias that overrides react-native with a path to a
// dummy file. So here it is!
export default {}
